import { gql } from '@apollo/client';

export const FETCH_USERS_ACTIVITY = gql`
  query FetchActivitiesQuery(
    $limit: Float!
    $cursorPaging: String
    $search: String
    $selectedDate: [String!]
    $filterItems: [ActivityFilterItems!]
    $teamList: [ActivityTeamList!]
  ) {
    fetchActivities(
      limit: $limit
      cursorPaging: $cursorPaging
      search: $search
      selectedDate: $selectedDate
      filterItems: $filterItems
      teamList: $teamList
    ) {
      activityCount
      pagingMetadata {
        cursor
        hasNext
      }
      activities {
        _id
        proposal {
          _id
          name
          proposalInfo
        }
        user {
          _id
          name
          image
          userInfo
        }
        teamId
        type
        createdAt
      }
    }
  }
`;
